export default class SalesWhatsappChannelStatusModel {
  connectionActive!: boolean;
}
